import { render, staticRenderFns } from "./RegionSearchSelectorVer2.vue?vue&type=template&id=467bb6cc&scoped=true&"
import script from "./RegionSearchSelectorVer2.vue?vue&type=script&lang=js&"
export * from "./RegionSearchSelectorVer2.vue?vue&type=script&lang=js&"
import style0 from "./RegionSearchSelectorVer2.vue?vue&type=style&index=0&id=467bb6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bb6cc",
  null
  
)

export default component.exports